export enum StudentNavigationHeader {
  STUDENT_INFO = "STUDENT_INFO",
  PARENT_INFO = "PARENT_INFO",
  GUARDIAN_INFO = "GUARDIAN_INFO",
  STUDENT_SCHOOL_FEES = "STUDENT_SCHOOL_FEES",
}

export enum ParentNavigationHeader {
  PARENT_INFO = "PARENT_INFO",
  STUDENT = "STUDENT",
}

export enum TeacherNavigationHeader {
  TEACHER_INFO = "TEACHER_INFO",
  STUDENTS = "STUDENTS",
}

export enum ResultNavigationHeader {
  SUDENT_RESULT_DETAIL = "SUDENT_RESULT_DETAIL",
}

export enum SchoolPricesNavigationHeader {
  LUNCH_PACKAGES = "LUNCH_PACKAGES",
  ACADEMIC_PRICE = "ACADEMIC_PRICE",
}
